export default __webpack_public_path__ + "static/media/Delhi.ac855bdf.png";